const Connect = require("react-redux").connect;
const BodyModelForm = require("components/BodyModelForm");
const CroquisAct = require("actions/croquis");
const SnackbarAct = require("actions/snackbar");

const internals = {};

internals.connect = Connect(
    state => ({
        croquis: state.croquis.all.new,
        submitText: "Create My Body Model"
    }),
    {
        updateFieldAction: CroquisAct.croquisMeasurementUpdate,
        updateTitleAction: CroquisAct.croquisTitleUpdate,
        onSubmitClick: CroquisAct.create,
        onError: SnackbarAct.messageSnackbar
    }
);

module.exports = internals.connect(BodyModelForm);



// WEBPACK FOOTER //
// ./src/routes/body-model-new/containers/BodyModelNew.js